import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type AirActionTrackingLocation } from '../types';
import META from './useTrackDownloadedItems.meta';

export type TrackDownloadedItemsParams = {
  altResolutionIds?: string[];
  boardIds?: string[];
  clipIds?: string[];
  collectionIds?: string[];
  location: AirActionTrackingLocation;
};

/**
 * Use this hook to track when a user downloads any combination of clips/boards/collections (private or public)
 */
export const useTrackDownloadedItems = () => {
  const { track } = useAnalyticsUtilities();

  const trackDownloadedItems = useCallback(
    (params: TrackDownloadedItemsParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackDownloadedItems };
};
